module.exports = __webpack_public_path__ + "img/21000.50889af3.jpg";